import {
  Container,
  Flex,
  Padlock,
  Title,
  Subtitle
} from './styles'

export const LockedCategoryPlacehoder = () => {
  return (
    <Container>
      <Flex style={{ flexDirection: "column", alignItems: "center", textAlign: "center", width: "100%" }}>
        <Padlock>🔒</Padlock>
        <div style={{ height: 16 }} />
        <Title>Hay categorías que todavía no viste</Title>
        <div style={{ height: 8 }} />
        <Subtitle>
          La próxima categoría avanzada se liberará en 2 meses.
        </Subtitle>
      </Flex>
    </Container>
  )
}